import { createFileRoute, Outlet } from '@tanstack/react-router'

import type { SiteId } from '@beaded/models'

import { readingQueries, siteQueries } from 'lib/queries'

export const Route = createFileRoute('/_auth/sites/$id')({
  component: () => <Outlet />,
  loader: ({ context: { queryClient }, params: { id } }) => {
    const siteId = Number(id) as SiteId
    void queryClient.prefetchQuery(siteQueries.detail(siteId))
    void queryClient.prefetchQuery(readingQueries.siteLines(siteId))
  },
})
